import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api/api';
import { Box, Card, CardContent, Stack, Typography, Divider } from '@mui/material';
import EventNoteIcon from '@mui/icons-material/EventNote';
import Loading from '../components/loading';
import logoDashboard from '../assets/logo_dashboard.png';

export default function HomeMobile() {
    const navigate = useNavigate();
    const [reminders, setReminders] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const getAllReminders = useCallback(() => {
        setIsLoading(true);
        api.get('/reminders', {
            headers: {
                Authorization: sessionStorage.getItem('token'),
            },
        }).then((returnFromApi) => {
            setReminders(returnFromApi.data);
        }).catch((returnFromApi) => {
            console.error('Erro ao buscar lembretes:', returnFromApi);
            if (returnFromApi.status === 401) {
                navigate("/expired-session");
            }
        }).finally(() => {
            setIsLoading(false);
        });
    }, [navigate]);

    useEffect(() => {
        getAllReminders();
    }, [getAllReminders]);


    return (
        <Box sx={{
            width: '100%',
            padding: '16px',
            boxSizing: 'border-box',
            overflowX: 'hidden'
        }}>

            <Stack spacing={2}>

                <Card sx={{
                    borderRadius: '16px',
                    boxShadow: 'none',
                    width: 300,
                    height: 150,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}>
                    <img
                        src={logoDashboard}
                        alt="Imagem"
                        style={{
                            maxWidth: "200px",
                            maxHeight: "200px",
                            objectFit: "contain",
                        }}
                    />
                </Card>

                <Card sx={{ borderRadius: '16px', boxShadow: 'none', overflow: 'hidden' }}>
                    <CardContent>
                        <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2, color: 'text.secondary' }}>
                            Lembretes
                        </Typography>

                        {isLoading && (
                            <Loading />
                        )}

                        {!isLoading && reminders.length === 0 && (
                            <Typography sx={{ textAlign: 'center', color: 'text.secondary', my: 3 }}>
                                Nenhum lembrete no momento.
                            </Typography>
                        )}

                        {!isLoading && reminders.length > 0 && (
                            <Stack spacing={2} divider={<Divider />}>
                                {reminders.map((reminder) => (
                                    <Box
                                        key={reminder.id}
                                        sx={{ display: 'flex', alignItems: 'center', padding: '8px 0' }}
                                    >
                                        <EventNoteIcon sx={{ color: 'text.secondary', mr: 2 }} />

                                        <Box sx={{ minWidth: 0 }}>
                                            <Typography variant="body2" sx={{
                                                fontWeight: 'bold',
                                                overflowWrap: 'break-word',
                                                wordBreak: 'break-all',
                                                whiteSpace: 'normal'
                                            }}>
                                                {reminder.title}
                                            </Typography>
                                            <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                                                {reminder.type}
                                            </Typography>
                                        </Box>
                                    </Box>
                                ))}
                            </Stack>
                        )}
                    </CardContent>
                </Card>

            </Stack>
        </Box>
    );
}